import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="hero section">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column justify-content-top" data-aos="fade-up">
            <h1>Overview of the Company</h1>
            <p>At Swotonn Labs, we are driven by our passion for improving healthcare accessibility. With a commitment to quality, innovation, and customer satisfaction, we provide a diverse range of pharmaceutical products that meet the highest standards.</p>
            <div className="d-flex">
              <a href="#about" className="btn-get-started">Get Started</a>
              <a href="https://www.youtube.com/watch?v=Y7f98aduVJ8" className="glightbox btn-watch-video d-flex align-items-center">
                <i className="bi bi-play-circle"></i>
                <span>Watch Video</span>
              </a>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-out" data-aos-delay="100">
            <img src="/assets/img/hero-img.jpeg" className="img-fluid animated" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
